import React, { useContext, useEffect } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'
import { Footer } from 'goustouicomponents/dist/Footer'
import PropTypes from 'prop-types'
import { QueryClientProvider } from 'react-query'
import { queryClient } from '../../utils'
import { client, goustoAPI } from '../../config/routes'
import { Help } from '../../routes/Help'
import { Categories } from '../../routes/Categories'
import { Article } from '../../routes/Article'
import { Section } from '../../routes/Section'
import { HeaderContainer } from '../HeaderContainer'
import { ScrollToTop } from '../ScrollToTop'
import { useFetch } from '../../hooks/useFetch'
import { store } from '../../store'
import { setUserDetails } from '../../actions/user'
import { getIsAuthenticated } from '../../selectors/auth'
import { OptimizelyProvider } from '../../optimizely/index'
import { ContentLoader } from '../ContentLoader'
import { Search } from '../Search'

const AppContent = ({ basename }) => {
  const { dispatch, state } = useContext(store)

  const { isFetchLoading, fetchError, fetchResponse } = useFetch({
    url: goustoAPI.currentUser,
    needsAuthorization: true,
  })

  useEffect(() => {
    if (
      !isFetchLoading
      && !fetchError
      && fetchResponse?.result?.data?.user
    ) {
      /* eslint-disable camelcase */
      const {
        name_first,
        name_last,
        id,
        email,
        gousto_reference,
      } = fetchResponse.result.data.user

      dispatch(setUserDetails({
        firstName: name_first,
        lastName: name_last,
        id,
        email,
        goustoReference: gousto_reference,
      }))
      /* eslint-enable camelcase */
    }
  }, [dispatch, isFetchLoading, fetchError, fetchResponse])

  const isAuthenticated = getIsAuthenticated(state) || false
  const userId = fetchResponse?.result?.data?.user.id
  const isUserLoading = !fetchError && !userId

  return isUserLoading ? <ContentLoader />
    : (
      <OptimizelyProvider userId={userId}>
        <QueryClientProvider client={queryClient}>
          <HeaderContainer />
          <Router basename={basename}>
            <ScrollToTop />
            <Switch>
              <Route path={`${client.article}/:name/:id`} component={Article} />
              <Route path={`${client.categories}/:categoryId${client.sections}/:sectionName/:sectionId`} component={Section} />
              <Route path={`${client.categories}/:name/:id`} component={Categories} />
              <Route path={`${client.search}`} component={Search} />
              <Route path="*" component={Help} />
            </Switch>
          </Router>
          <Footer hasDataTracking isAuthenticated={isAuthenticated} />
        </QueryClientProvider>
      </OptimizelyProvider>
    )
}

AppContent.propTypes = {
  basename: PropTypes.string.isRequired,
}

export { AppContent }
